import { useMutation, UseMutationResult } from 'react-query';
import { api } from '../api';
import queryClient from '../query-client';
import { PostResponseBody } from '../types/api-response';
import { AxiosError } from 'axios';
import { UserOverview } from '../types/user';
import { Procedure } from '../types/procedure';

export type CreateProceduresRequest = {
    templateId: string;
    procedures: { name: string; description: string; role: string; entityTypes: string[]; categoryId?: string }[];
};

export type ProceduresResponse = {
    id: string;
    name: string;
    createdAt: string;
    updatedAt: string;
    createdBy: UserOverview;
    categories: [{ name: string; id: string; createdAt: Date; updatedAt: Date }];
    procedures: Procedure[];
};

async function createProcedures(req: CreateProceduresRequest): Promise<PostResponseBody<ProceduresResponse>> {
    const templateId = req.templateId;
    const { data } = await api.post(`/procedures/templates/${templateId}/procedures`, { procedures: req.procedures });
    return data;
}

export function useCreateProcedures(): UseMutationResult<
    PostResponseBody<ProceduresResponse>,
    AxiosError,
    CreateProceduresRequest,
    unknown
> {
    return useMutation((req) => createProcedures(req), {
        onSettled: () => {
            queryClient.invalidateQueries(['procedures-templates']);
        },
    });
}
